import React from "react";
import "./Portfolio.css";
import { Link } from "react-router-dom";
import {
  Binocular,
  Bluetooth,
  Serum,
  canVideo,
  phone,
} from "../../assets/images";
import ThreeSixty from "react-360-view";
import GlassesTryingOn from "./Glasses/Glasses";
import { useCursor } from "../../shared/config/cursorProvider";
const posts = [
  {
    title: "Allets Network",
    description: "Building responsive web applications",
    iframeSrc: "https://alletsnw.com/",
  },
  {
    title: "Moin Digital Services",
    description: "A website for Cosmetix",
    iframeSrc: "https://moindigitalservices.com/",
  },
  {
    title: "Duckman Studio",
    description: "A website for Cosmetix",
    iframeSrc: "https://www.duckmanstudio.com/",
  },
  {
    title: "Amologic Private Limited",
    description: "A website for Cosmetix",
    iframeSrc: "https://www.amologic.com/",
  },
];
export default function Portfolio() {
  const cursorPosition = useCursor();

  const basePath = "https://fastly-production.24c.in/webin/360";
  return (
    <div className="portfolio-container">
      <div
        className="custom-1"
        style={{ left: cursorPosition.x, top: cursorPosition.y }}
      ></div>
      <div
        className="custom-cursor"
        style={{ left: cursorPosition.x, top: cursorPosition.y }}
      ></div>
      <div className="portfolio-header">
        <div className="p-content">
          <h2 className="title-text">
            Explore Our Work: Your{" "}
            <span className="highlight-txt">Success,</span> Our{" "}
            <span className="highlight-txt">Expertise</span>
          </h2>
          <p>Turning Ideas into Digital Symphonies</p>
        </div>
        <div className="header-img">
          <img
            src="https://unitedthemes.com/wp-content/uploads/2018/05/Drag-Drop-Page-Builder..png"
            alt=""
          />
        </div>
      </div>
      <div className="p-section-two">
        {" "}
        <div className="portfolio-posts">
          {posts.map((post, index) => (
            <Link
              to={post.iframeSrc}
              target="_blank"
              className="post"
              key={index}
            >
              <h3>{post.title}</h3>
              <div style={{ width: '100%'}}>
                <iframe
                  src={post.iframeSrc}
                  height="auto"
                  width="100%"
                  title={`Iframe Example ${index + 1}`}
                ></iframe>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div className="rotating-modals">
        <div className="rotating-car">
          <p>Rotate The Car in 360 deg</p>
          <ThreeSixty
            amount={75}
            imagePath={basePath}
            fileName="output_{index}.jpeg"
            // spinReverse
            className="rotate-on-desktop"
            spin
          />
        </div>
        <div>
          <p>Try Glasses</p>
          <GlassesTryingOn />
        </div>
      </div>
      <div className="modals">
        <h2 className="title-text">
          Architects of Digital Dreams: Arman Visions x 3D Modals Revolution
        </h2>
        <div className="can-animation">
          <div className="can-video">
            <img src={canVideo} alt="" />
          </div>
        </div>
        <div className="assets-collage">
          <img src={Serum} alt="" />
          <img src={Bluetooth} alt="" />
          <img src={Binocular} alt="" />
          <img src={phone} alt="" />
        </div>
      </div>
    </div>
  );
}
